import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "react-toastify";

import { updateOption } from "../../services/option";
import { IIndicators } from "../../types/indicator";

const useUpdateOption = (indicator: IIndicators) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updateOption,
        onMutate: () => {
            indicator.setIsProcessRunning(true);
            indicator.setIsServiceError(null);
        },
        onSuccess: (statusCode) => {
            if (statusCode === 200) {
                queryClient.invalidateQueries({ queryKey: ["question-options"] });
                indicator.setIsProcessRunning(false);
                indicator.setIsServiceError(null);
                toast.success("Action updated successfully!");
            }
        },
        onError: (error: any) => {
            indicator.setIsServiceError(error.response?.data?.message);
            indicator.setIsProcessRunning(false);
            toast.error(error.response?.data?.message);
            throw Error;
        }
    })
}

export default useUpdateOption;